import { environments, languageNames } from '../../i18n/environments';
import useCurrentLanguage from '../../i18n/useCurrentLanguage';
import useLocationPathName from '../../i18n/useLocationPathName';
import { flags } from '../../i18n/flags';

const useLanguageLinks = () => {
  const { esPagesToExclude } = require(`../../../workers-site/excludedPages`);
  const alternates = environments[process.env.REACT_APP_ENV]?.alternates ?? [];

  const locationPathName = useLocationPathName();
  const { currentLanguage } = useCurrentLanguage();

  const alternatesLinks = alternates
    .filter((alternate) => {
      if (alternate.lang === 'es') {
        if (esPagesToExclude.includes('/' + locationPathName)) {
          return false;
        }
      }
      return true;
    })
    .map((x) => ({
      ...x,
      flag: flags[x.lang],
      flag_bold: flags[x.lang + '-bold'],
      path: x.path + locationPathName,
      isCurrent: x.lang === currentLanguage,
      languageName: languageNames[x.lang],
    }));

  return alternatesLinks;
};

export default useLanguageLinks;
